import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';

import { commonConstant, StickyBottom } from '../../common';
import { customerService } from '../../services';
import { setDynamicRichMenu } from '../../actions';
import config from '../../config';
import { DETAIL_TYPE_LISTING, LABEL_GET_STARTED } from '../../common/commonConstant';
import ListingItem from '../home/components/listingItem/ListingItem';
// const liff = window.liff;
const { liff } = window;
export class Success extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: null,
      loading: true,
      redirect: null,
    };
  }


  async componentDidMount() {
    if (sessionStorage.getItem('customer') === null || sessionStorage.getItem('customer') === 'undefined') {
      return window.location.replace(commonConstant.pathHome);
    }

    const customer = JSON.parse(sessionStorage.getItem('customer'));
    let params = {
      action: 'REGISTER_COMPLETE',
      socialType: 'LINE',
    }
    if (customer.registerStatus !== 'complete' || this.props.customer?.type === 'public') {
      params = {
        ...params,
        registerStatus: 'complete',
        registerDate: new Date(),
        name: customer.name,
        _id: customer._id,
        info: customer.info,
        amwayNumber: customer.amwayNumber,
        partyId: customer.partyId,
        socialType: customer.socialType,
        cid: customer.cid,
        birthday: customer.birthday,
        ...(customer?.gender && { gender: customer.gender }),
        ...(customer?.phone && { phone: customer.phone }),
        type: customer.type,
        pictureUrl: customer.pictureUrl,
        displayName: customer.displayName,
        uid: customer.uid,
        status: "unblock"
      };
    }

    if (customer._id) {
      await customerService.update(customer._id, params);
    } else {
      await customerService.create(params);
    }

    await this.props.setDynamicRichMenu({ ...customer, registerStatus: 'complete' });
    if (!sessionStorage.getItem('customer')) {
      customerService.get(customer.uid).then((res) => {
        sessionStorage.setItem('customer', JSON.stringify(res))
        this.setState({
          userInfo: res,
          loading: false,
        });
      });
    } else {
      this.setState({
        userInfo: JSON.parse(sessionStorage.getItem('customer')),
        loading: false,
      });
    }
  }

  handleButton = () => {
    liff.closeWindow();
  }

  handleButtonInterest = async () => {
    if (sessionStorage.getItem('customer') === null || sessionStorage.getItem('customer') === 'undefined') {
      return window.location.replace(commonConstant.pathHome);
    }

    const customer = JSON.parse(sessionStorage.getItem('customer'));
    const params = {
      action: 'SELECT_PRODUCT',
    };
    await customerService.update(customer._id, params);
    this.setState({
      redirect: '/interest',
    });
  }

  render() {
    const { redirect } = this.state;
    if (redirect) {
      return <Redirect to={redirect} />;
    }
    if (this.state.loading) {
      return <LoadingOverlay active={this.state.loading} spinner text="Loading" styles={{ wrapper: { width: '100%', minHeight: '100%' } }} />;
    }
    const { pictureUrl, displayName, amwayNumber, type } = this.state.userInfo;
    const detailType = this.props.location.state?.detailType;
    return (
      <div className='success-container'>
        <div className="Success">
          <div className="logoAmway">
            <img src="/images/logoAmway-success.png" alt="" />
          </div>
          <h2>ลงทะเบียนสำเร็จ!</h2>
          <div className='picture-container'>
            <div className="picture">
              <img src={pictureUrl || config.AVATAR_DEFAULT} alt="" />
            </div>
          </div>
          <h2 className="name">คุณ {displayName}</h2>
          {
            amwayNumber && (
              <h2 className="away-num">
                {type === 'abo' ? 'หมายเลขนักธุรกิจ' : 'หมายเลขสมาชิก'} : {amwayNumber || '-'}
              </h2>
            )
          }
          <div className="detail">
            <h3>ขอบคุณสำหรับการลงทะเบียน<br />คุณจะได้รับประสบการณ์การใช้งานที่ดียิ่งขึ้น!</h3>
            <div className='listing-items-container'>
              {DETAIL_TYPE_LISTING[detailType || 'abo'].map((textItem, index) => <ListingItem key={index} title={textItem} />)}
            </div>
          </div>
          {/* TODO: remove comment after final integration of Registration flow */}
          {/* <div className="footer">
          {type === 'no' ? <button onClick={this.handleButtonInterest} className="away-button">เลือกหัวข้อที่สนใจใหม่</button> : null}
          <button onClick={this.handleButton} className="away-button active">ปิด</button>
        </div> */}
        </div>
        <StickyBottom onClick={this.handleButton} buttonText={LABEL_GET_STARTED} isActive={true} buttonProps={{ type: "submit", style: { marginTop: 20 } }} >
        </StickyBottom>
      </div>
    );
  }
}

function mapStateToProps({ profile, customer }) {
  return { profile, customer };
}

const mapDispatchToProps = (dispatch) => ({
  setDynamicRichMenu: customer => setDynamicRichMenu(dispatch, customer),
});

export default connect(mapStateToProps, mapDispatchToProps)(Success);
